import { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { FaFacebookF, FaInstagram, FaPhone, FaWhatsapp } from "react-icons/fa6";

export default function FooterSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.3 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const variants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <motion.footer
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={variants}
      className="bg-black text-white px-6 md:px-20 py-16"
    >
      <div id="footer" className="flex flex-col items-center gap-8">
        <h2 className="text-xl font-semibold">CONNECT WITH US</h2>

        {/* Social + Contact Icons */}
        <div className="flex gap-6 text-2xl">
          {/* Phone */}
          <a
            href="tel:+919220512266"
            className="hover:text-green-400 transition-colors"
          >
            <FaPhone />
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/share/1BPGgzaT9F/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-500 transition-colors"
          >
            <FaFacebookF />
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/ashwalaya?igsh=eHh5NXI2anIydXQ3"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-pink-500 transition-colors"
          >
            <FaInstagram />
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/919928512266"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-green-500 transition-colors"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>

      {/* Footer bottom line */}
      <div className="text-center text-gray-500 text-sm mt-16 border-t border-gray-700 pt-6">
        © <i>Ashwalaya</i>
      </div>
    </motion.footer>
  );
}